import ListView from '../../../components/listView/ListView'
import WidgetPage from '../../../components/widgetPage/WidgetPage'
import Page from '../../../components/pageView/Page'
import DocumentBrowser from '../../../components/documents/DocumentBrowser/DocumentBrowser'

const routesDocuments = [
    {
        path: "/documents",
        element: WidgetPage,
        props: {
            type: 'documents',
            draggable: false,
            resizable: false
        }
    },
    {
        path: "/documents/browser",
        element: DocumentBrowser,
        props: {}
    },
    {
        path: "/documents/document",
        element: ListView,
        props: { type: 'documentList' }
    },
    {
        path: "/documents/document/:id",
        element: Page,
        props: {
            type: 'documentPage',
            options: { mode: 'edit', load: true, onMount: 'collapse', resizeable: true }
        }
    },
    {
        path: "/documents/document/new",
        element: Page,
        props: {
            type: 'documentPage',
            options: { mode: 'new' }
        }
    },
    {
        path: "/documents/folder",
        element: ListView,
        props: { type: 'folderList' }
    },
    {
        path: "/documents/folder/:id",
        element: Page,
        props: {
            type: 'folderPage',
            options: { mode: 'edit', load: true }
        }
    },
    {
        path: "/documents/folder/new",
        element: Page,
        props: {
            type: 'folderPage',
            options: { mode: 'new' }
        }
    }
]

export default routesDocuments
